import { useTransactions } from '@api/hooks/useTransactions';
import Link from '@components/link';
import { useBankProfile } from '@contexts/BankProfileContext';
import { useTranslation } from 'react-i18next';
import { OperationStatus } from 'types/operations';

import { ApprovalsTable } from './ApprovalsTable';

const CURRENT_PAGE = 1;
const PAGE_LIMIT = 4;

export const Approvals = () => {
	const { t } = useTranslation('', { keyPrefix: 'dashboard' });
	const { selectedProfile } = useBankProfile();

	const { data, isLoading } = useTransactions(
		selectedProfile?.id ?? '',
		CURRENT_PAGE,
		PAGE_LIMIT,
		undefined,
		undefined,
		undefined,
		undefined,
		[OperationStatus.CREATED],
	);

	const transactions = data?.items ?? [];
	const hasTransactions = Boolean(transactions.length);

	return (
		<>
			{!isLoading && hasTransactions && (
				<div className="flex w-full items-center justify-end">
					<Link
						className="ml-auto h-5 text-brand-secondary-600 hover:text-neutral-950 hover:border-b transition"
						to="/operations?status=created"
					>
						{t('approvals.allApprovals')}
					</Link>
				</div>
			)}

			<ApprovalsTable isLoading={isLoading} transactions={transactions} />
		</>
	);
};
